export default __webpack_public_path__ + "media/color/btcz-39199a0c.svg";